const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.play();
            videoObserver.unobserve(entry.target);
        }
    });
}, { threshold: 0 });

/**
 * Play the videos when they appear on viewport
 */
function observeAndPlayProductDetailVideos() {
    const pdpVideos = document.getElementsByClassName('pdp-video');
    for (let i = 0; i < pdpVideos.length; i++) {
        const video = pdpVideos[i];
        if (video.getAttribute('data-autoplay')) {
            videoObserver.observe(video);
        }
    }
}

module.exports = function () {
    observeAndPlayProductDetailVideos();

    $(document).on('product:image-slider-created', function () {
        observeAndPlayProductDetailVideos();
    });
};
